import { locale } from '../locale';
import { STANDARD_DATE_FORMAT } from '../const';
/**
 * 根据语种信息获取日期格式化配置
 * @param lang 语种
 * @returns
 */
export const getDateFormatConf = function (lang) {
    var _a;
    return {
        ...STANDARD_DATE_FORMAT,
        ...(((_a = locale[lang]) === null || _a === void 0 ? void 0 : _a.DATE_FORMATS) || null),
    };
};
/**
 * 将国际标准格式兑换成本地格式
 * @param stdFormat
 * @param lang 语种
 * @returns
 */
export function getDateFormatByStd(stdFormat, lang) {
    const formatConfs = getDateFormatConf(lang);
    const formatConfStds = getDateFormatConf('zh-CN');
    const key = Object.keys(formatConfStds).find((k) => formatConfStds[k] === stdFormat);
    if (!key) {
        return stdFormat;
    }
    return formatConfs[key] || stdFormat;
}
/**
 * 获取系统时区信息
 * @returns
 */
export const getTimezone = function () {
    return this.dayjs.tz.guess();
};
/**
 * 根据时间戳获取当前日期偏移量
 * @param this
 * @param num
 * @param timezone
 * @param lang
 * @returns
 */
export const getTimezoneName = function (num, timezone, lang) {
    const options = { timeZone: timezone, timeZoneName: 'long' };
    const formatter = new Intl.DateTimeFormat(lang, options);
    const parts = formatter.formatToParts(num ? +num : new Date());
    const zoneNamePart = parts.find((part) => part.type === 'timeZoneName');
    return zoneNamePart ? zoneNamePart.value : null;
};
/**
 * 根据当前语种&时区格式化时间戳
 * @param this
 * @param num
 * @param opts
 * @returns
 */
export const dateFormat = function (num, opts) {
    return this.dayjs(num).tz(opts.timezone).format(opts.format);
};
/**
 * 根据当前语种&时区获取时间戳
 * @param this
 * @param dateStr string
 * @param opts FormatOpts
 * @returns
 */
export const dateTimestamp = function (dateStr, opts) {
    if (!(opts === null || opts === void 0 ? void 0 : opts.format)) {
        return this.dayjs(dateStr).tz(opts === null || opts === void 0 ? void 0 : opts.timezone, true).valueOf();
    }
    return this.dayjs(dateStr, opts === null || opts === void 0 ? void 0 : opts.format).tz(opts === null || opts === void 0 ? void 0 : opts.timezone, true).valueOf();
};
/**
 * 根据时间戳获取当前日期偏移量
 * @param this
 * @param num
 * @param timezone
 */
export const getTimezoneOffset = function (num, timezone) {
    const offset = this.dayjs(num).tz(timezone).utcOffset();
    const timeStr = this.dayjs(num).tz(timezone).format();
    return {
        offset,
        offsetText: timeStr.slice(timeStr.length - 6, timeStr.length),
    };
};
/**
 * 设置 dayjs 对象时区
 * @param this
 * @param day
 * @param timezone
 * @param keepLocalTime 是否保持本地时间
 * @returns 新的 dayjs 对象
 */
export const dayjsTz = function (day, timezone, keepLocalTime) {
    if (typeof day === 'object' && day.valueOf) {
        return this.dayjs(day.valueOf()).tz(timezone, keepLocalTime);
    }
    return this.dayjs(day).tz(timezone, keepLocalTime);
};
